import React, { useState } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import DPEForm from "./DPEForm"
import DPETable from "./DPETable"

// DPE.js is intentionally minimal: it owns only the cross-component selection
// state (selectedDPEId) and wires the two data-owning siblings together.
// All fetching, mutations, and error handling live in DPEForm and DPETable.

export default function DPE({ supabase }) {
    const [selectedDPEId, setSelectedDPEId] = useState(null)

    // Reset selection after a successful form submission (add / update / delete)
    const handleFormSuccess = () => setSelectedDPEId(null)

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>

                {/* ── Form column ──────────────────────────────────────── */}
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedDPEId ? "Modifier un DPE" : "Ajouter un DPE"}
                    </Typography>
                    <DPEForm
                        supabase={supabase}
                        selectedDPEId={selectedDPEId}
                        onSuccess={handleFormSuccess}
                    />
                </Grid>

                {/* ── Table column ─────────────────────────────────────── */}
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Liste des DPE
                    </Typography>
                    <DPETable
                        supabase={supabase}
                        selectedDPEId={selectedDPEId}
                        setSelectedDPEId={setSelectedDPEId}
                    />
                </Grid>

            </Grid>
        </Box>
    )
}